// Limits and choices for creating a secret (AGENT_BRIEF Phase 1: text up to
// 100 KB, 1–10 views, expiry 5 minutes to 7 days). The Worker enforces the
// same SECRET_LIMITS again.

import { SECRET_LIMITS } from '@sss/types';

export const MAX_SECRET_BYTES = SECRET_LIMITS.maxTextBytes;

export const VIEW_OPTIONS = [1, 2, 3, 5, 10] as const;
export type ViewOption = (typeof VIEW_OPTIONS)[number];

/** Expiry choices in seconds, keyed for i18n (`create.expiry.<key>`). */
export const EXPIRY_OPTIONS = [
  { key: '5m', seconds: 5 * 60 },
  { key: '1h', seconds: 60 * 60 },
  { key: '1d', seconds: 24 * 60 * 60 },
  { key: '7d', seconds: 7 * 24 * 60 * 60 },
] as const;
export type ExpiryKey = (typeof EXPIRY_OPTIONS)[number]['key'];

export const expirySeconds = (key: ExpiryKey): number => EXPIRY_OPTIONS.find((o) => o.key === key)?.seconds ?? SECRET_LIMITS.maxExpirySeconds;

const encoder = new TextEncoder();

/** Size of `text` as sent (UTF-8), which is what the limit applies to. */
export const utf8ByteLength = (text: string): number => encoder.encode(text).length;

export const formatKilobytes = (bytes: number): string => `${Math.ceil(bytes / 1024)} KB`;

export type SecretTextProblem = 'empty' | 'tooLarge' | null;

export const checkSecretText = (text: string): SecretTextProblem => {
  if (text.trim().length === 0) return 'empty';
  if (utf8ByteLength(text) > MAX_SECRET_BYTES) return 'tooLarge';
  return null;
};
